import { Box, Typography, styled } from "@mui/material"
import { COLORS } from "../../../utils"


export const PEPSEResumeContainer = styled("div", {
  shouldForwardProp: (prop) => prop !== "isFitCornerTag"
})(({ isFitCornerTag = false }) => ({
  background: isFitCornerTag ? COLORS.GREEN_SUCCESS_100 : COLORS.BACKGROUND_GREY,
  color: COLORS.BLACK800,
  borderRadius: "8px",
  padding: "24px",
  height: "100%",
  flex: 1
}))

export const PEPSEResumeLabel = styled(Typography)({
  fontSize: 14,
  lineHeight: "22px",
  color: COLORS.LABEL_GREY,
})

export const PEPSEMultiplePackagingInfo = styled(Typography)({
  fontSize: 14,
  lineHeight: "14px",
  backgroundColor: "white",
  width:"fit-content",
  padding: "4px 16px",
  border: "1px solid #000",
  borderRadius: "43px"
})

export const PEPSEResumeInfo = styled(Typography)({
  fontSize: 16,
  lineHeight: "24px",
  color: COLORS.BLACK800
})

export const StyledContainer = styled(Box)({
  padding: 24,
  borderRadius: "8px",
  border: "1px solid #E6E6E6"
})

export const StyledErrorMessage = styled(Typography)({
  color: "#F44259",
  fontSize: 14,
  fontWeight: 400,
  lineHeight: "22px",
  marginTop: 6
})